<template>
	<MStateBox :loading="initialLoading" :empty="isEmpty" class="act-container">
		<CScrollPro
			ref="scrollRef"
			pullDown
			@pull-down="onPullDown"
			pullUp
			:moreData="hasMoreData"
			@pull-up="onPullUp"
			contentClassName="act-scroll-box"
		>
			<div
				v-for="(item, index) in finalData"
				:key="index"
				class="research-item"
				@click="viewResearchDetail(item)"
			>
				<div class="research-info">
					<img class="list-icon" src="@/assets/images/irstore/touguantiaoyan.svg" alt="" />
					<span>纪要</span>
					<span class="research-time">{{ dateFormatYearMonthDate(item.ptime) }}</span>
				</div>
				<div class="research-title">{{ item.title }}</div>
				<div class="research-author">{{ item.stockName }} {{ toCode(item.fullCode) }}</div>
			</div>
		</CScrollPro>
	</MStateBox>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import MStateBox from '@rebuild/components/MStateBox.vue';
import CScrollPro from '@/view/enterprise/components/c-scroll-pro.vue';
import { dateFormatYearMonthDate } from '@/utils/api';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { usePaginationMobile } from '@rebuild/hooks/load-more/usePaginationMobile';

const { viewModule } = useModuleNavigation();
const { research } = useModuleData();

const viewResearchDetail = item => viewModule('research', item);
const toCode = code => {
	if (!code) return;
	let letters = code.match(/[A-Za-z]+/g)[0];
	let numbers = code.match(/[0-9]+/g)[0];
	return numbers + '.' + letters.toUpperCase();
};

const loadData = async () => {
	await research.refresh({ pagestart: currentPage.value - 1, pagenum: pageSize.value });

	const data = research.data;
	const newData = data?.rows || [];
	const total = data?.total || 0;
	setData(newData, total);
};

const { currentPage, pageSize, finalData, setData, hasMoreData, onPullDown, onPullUp } = usePaginationMobile({
	bindChange: loadData
});

// 首屏加载
const initialLoading = ref(true);
const isEmpty = computed(() => !initialLoading.value && finalData.value.length === 0);

onMounted(async () => {
	await loadData();
	initialLoading.value = false;
});
</script>

<style lang="less" scoped>
@import '@/style/mixin/text-overflow.less';
.act-container {
	height: 100%;
}
.research-item {
	margin-bottom: 0.08rem;
	font-family: 'PingFang SC';
	width: 100%;
	padding: 0.12rem;
	background: #ffffff;
	.research-info {
		display: flex;
		font-style: normal;
		font-weight: 400;
		font-size: 0.12rem;
		line-height: 0.17rem;
		color: #333333;
		.list-icon {
			margin-right: 0.08rem;
			width: 0.16rem;
			height: 0.16rem;
		}
	}
	.research-time {
		margin-left: 0.08rem;
		font-size: 0.11rem;
		line-height: 0.155rem;
		color: #666666;
	}
	.research-title {
		margin-top: 0.1rem;
		max-height: 0.72rem;
		font-style: normal;
		font-weight: 400;
		font-size: 0.16rem;
		line-height: 0.24rem;
		color: #333333;
		.text-overflow-multi-row(3);
	}
	.research-author {
		margin-top: 0.1rem;
		font-style: normal;
		font-weight: 400;
		font-size: 0.11rem;
		line-height: 0.155rem;
	}
}
</style>
